import React, { useEffect, useState } from "react";
import { hooks } from "../../hooks";
import { Routes } from "../../routes";
import { axiosInstance } from "../../api/api";
import patrolIcon from '../../assets/icons/shield.png';
import locationIcon from "../../assets/icons/location.png";
import {components} from '../../components';

import bgFactory from '../../assets/bg/factory-img.jpeg';

interface StatsData {
  totalPatroli: number;
  totalLokasi: number;
}

export const AdminDashboard: React.FC = () => {
  const navigate = hooks.useNavigate();
  const [stats, setStats] = useState<StatsData>({ totalPatroli: 0, totalLokasi: 0 });
  const [loading, setLoading] = useState(true);


  const fetchAllSpots = async (): Promise<number> => {
    try {
      let allSpots: any[] = [];
      let currentPage = 1;
      let hasMorePages = true;

      while (hasMorePages) {
        const res = await axiosInstance.get('/api/v1/patrol/asset/index', {
          params: { page: currentPage }
        });
        const pageData = res.data.data || [];
        allSpots = [...allSpots, ...pageData];
        hasMorePages = currentPage < res.data.last_page;
        currentPage++;
        if (currentPage > 20) break;
      }
      
      return allSpots.length;
    } catch (error) {
      console.error('Error fetching all spots:', error);
      return 0;
    }
  };

  const fetchAllPatrols = async (): Promise<number> => {
    try {
      let allPatrols: any[] = [];
      let currentPage = 1;
      let hasMorePages = true;

      while (hasMorePages) {
        const res = await axiosInstance.get('/api/v1/patrol/index', {
          params: { page: currentPage }
        });
        
        const pageData = res.data.data || [];
        allPatrols = [...allPatrols, ...pageData];
        hasMorePages = currentPage < res.data.last_page;
        currentPage++;
        
        if (currentPage > 20) break;
      }
      
      return allPatrols.length;
    } catch (error) {
      console.error('Error fetching all patrols:', error);
      return 0;
    }
  };

  const fetchStats = async () => {
    try {
      setLoading(true);
      const [totalPatroli, totalLokasi] = await Promise.all([
        fetchAllPatrols(),
        fetchAllSpots()
      ]);

      setStats({
        totalPatroli,
        totalLokasi
      });
    } catch (error) {
      console.error('Error fetching stats:', error);
      setStats({
        totalPatroli: 0,
        totalLokasi: 0
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStats();
  }, []);

  const buttonConfigs = [
    {
      text: "Kelola Patroli",
      onClick: () => navigate(Routes.PatrolFormTable),
      isPrimary: false,
    },
    {
      text: "Kelola Spot",
      onClick: () => navigate(Routes.KelolaPatrol),
      isPrimary: false,
    },
    // {
    //   text: "Kelola Pengguna Patroli",
    //   onClick: () => navigate(Routes.PatrolUser),
    //   isPrimary: false,
    // },
    {
      text: "Kelola Grup Patroli",
      onClick: () => navigate(Routes.GroupSpace),
      isPrimary: false,
    },
    
  ];

  return (
    <>
      <div id="screen" style={{ opacity:1 }}>
        <main className="scrollable container">
          <div className="stats-row">
            <div className="stat-card row-center-space-between">
              <div style={{width:"100%"}}>
                <p className="t14" style={{paddingBottom:10}}>Total Patroli</p>
                <h2>
                  {loading ? "..." : stats.totalPatroli}
                </h2>
              </div>
              <div style={{
                padding:10,
                backgroundColor:"#ccecee",
                borderRadius:8
              }}>
                <img src={patrolIcon} className='img-fluid' alt="" width={25} height={25} style={{opacity:0.5}}/>
              </div>
            </div>
            <div className="stat-card row-center-space-between">
              <div style={{width:"100%"}}>
                <p className="t14" style={{paddingBottom:10}}>Total Lokasi</p>
                <h2>
                  {loading ? "..." : stats.totalLokasi}
                </h2>
              </div>
              <div style={{
                padding:10,
                backgroundColor:"rgb(204,238,205)",
                borderRadius:8
              }}>
                <img src={locationIcon} className='img-fluid' alt="" width={25} height={25} style={{opacity:0.5}}/>
              </div>
            </div>
          </div>

          <div style={{
            backgroundImage: `url(${bgFactory})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'relative',
            width: '100%',
            height: '240px',
            marginBottom: 40,
            borderRadius:8,
          }}></div>

          <div className="actions-container">
            <div className="buttons-vertical">
              {buttonConfigs.map((button, index) => (
                // <button
                //   key={index}
                //   className={`action-button ${button.isPrimary ? 'primary' : 'secondary'}`}
                //   onClick={button.onClick}
                // >
                //   <span className="button-text">{button.text}</span>
                // </button>
                
                <components.Button
                  text={button.text}
                  containerStyle={{marginBottom: 5}}
                  onClick={button.onClick}
                />
              ))}
            </div>
          </div>
        </main>
      </div>

      <style>{`
        .section-title {
          color: #0d141b;
          font-size: 18px;
          font-weight: 700;
          line-height: 1.2;
          letter-spacing: -0.015em;
          padding: 0 16px 20px 16px;
          margin: 0;
        }

        .section-title:first-of-type {
          padding-top: 16px;
        }

        .stats-row {
          display: flex;
          gap: 16px;
          padding: 10px 0 20px;
        }

        .stat-card {
          gap: 8px;
          border-radius: 8px;
          padding: 15px;
          border: 1px solid #ccecee;
          background: white;
          align-items:end;
          width:100%;
        }

        .stat-label {
          color: #0d141b;
          font-size: 16px;
          font-weight: 500;
          line-height: normal;
          margin: 0;
        }

        .stat-value {
          color: #0d141b;
          font-size: 24px;
          font-weight: 700;
          line-height: 1.2;
          letter-spacing: -0.01em;
          margin: 0;
        }

        .actions-container {
          display: flex;
          justify-content: center;
        }

        .buttons-vertical {
          display: flex;
          flex-direction: column;
          gap: 12px;
          width: 100%;
          max-width: 480px;
        }

        .action-button {
          display: flex;
          min-width: 84px;
          max-width: 480px;
          cursor: pointer;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          border-radius: 8px;
          height: 48px;
          padding: 0 20px;
          border: none;
          font-size: 16px;
          font-weight: 700;
          line-height: normal;
          letter-spacing: 0.015em;
          width: 100%;
          transition: all 0.2s ease;
        }

        .action-button.primary {
          background: #1172d4;
          color: #f8fafc;
        }

        .action-button.primary:hover {
          background: #0d5fb6;
        }

        .action-button.secondary {
          background: #e7edf3;
          color: #0d141b;
        }

        .action-button.secondary:hover {
          background: #d8e1eb;
        }

        .button-text {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }

        @media (max-width: 768px) {

          .buttons-vertical {
            gap: 8px;
          }
        }
      `}</style>
    </>
  );
};